import { Injectable } from '@angular/core';
import { RolepermissionService } from 'src/app/services/rolepermission.service';

@Injectable({
  providedIn: 'root',
})
export class SidenavService {

  isPrivilege = localStorage.getItem('hasPriviledge') == '1' ? true : false;
  portalType = localStorage.getItem('userType');
  sideNav: any;
  // excludeNav: any[] = ['FAQs', 'Park Info', 'Deals', 'Bulletins'];
  // excludeNav: any[] = ['FAQs', 'Deals', 'Bulletins'];
  excludeNav: any[] = [];
  tempSelectedNav: any[] = [];
  newmainUserRoleList = [];
  defaultListCount: number = 5;

  bridgePlusNav = [
    {
      index: '0',
      name: 'Overview',
      image: '/assets/images/overview-inactive.png',
      selectedImage: '/assets/images/overview-active.png',
      link: '/overview',
      sub: [],
    },
    {
      index: '1',
      name: 'Access Card',
      image: '../../../assets/images/access_card.png',
      selectedImage: '../../../assets/images/access_card_selected.png',
      sub: [
        {
          index: '0',
          name: 'Bulk Upload',
          link: '/companies-rfid-bulkupload',
          sub: []
        },
        {
          index: '1',
          name: 'Tenant Allocation',
          link: '/disburse-member-card',
          sub: []
        },
      ],
    },
    {
      index: '2',
      name: 'Companies',
      image: '/assets/images/companies-inactive.png',
      selectedImage: '/assets/images/companies-active.png',
      link: '/companies/companies-list',
      sub: [],
    },
    {
      index: '3',
      name: 'Members',
      image: '/assets/images/members-inactive.png',
      selectedImage: '/assets/images/members-active.png',
      link: '/members/members-list',
      sub: [],
    },
    {
      index: '4',
      name: 'Meeting',
      link: '/meeting/meetingroom-list',
      image: '/assets/images/meeting-inactive.png',
      selectedImage: '/assets/images/meeting-active.png',
      sub: [],
    },

    {
      index: '5',
      name: 'Reports',
      image: '/assets/images/reports-inactive.png',
      selectedImage: '/assets/images/reports-active.png',
      link: '/reports',
      sub: [],
    },
    {
      index: '6',
      name: 'Credits',
      image: '/assets/images/credits-inactive.png',
      selectedImage: '/assets/images/credits-active.png',
      link: '/credits',
      sub: [],
    },
    {
      index: '7',
      name: 'Contact',
      image: '/assets/images/contact-book.png',
      selectedImage: '/assets/images/contact-active.png',
      link: '/contact',
      sub: [],
    },
    {
      index: '8',
      name: 'VMS',
      image: '../../../assets/images/vms.png',
      selectedImage: '../../../assets/images/vms_active.png',
      link: '/bridgeplus-vms',
      sub: [],
    },
    {
      index: '9',
      name: 'Events',
      image: '../../../assets/images/Events-1.png',
      selectedImage: '../../../assets/images/events_active.png',
      link: '/events',
      sub: [],
    },
    // {
    //   index: '8',
    //   name: 'Location',
    //   image: '/assets/images/location-inactive.png',
    //   selectedImage: '/assets/images/location-active.png',
    //   link: '',
    //   sub: [],
    // },
  ];

  tempBridgePlusNav = [
    {
      index: '0',
      name: 'Overview',
      image: '/assets/images/overview-inactive.png',
      selectedImage: '/assets/images/overview-active.png',
      link: '/overview',
      sub: [],
    },
    {
      index: '1',
      name: 'Access Card',
      image: '../../../assets/images/access_card.png',
      selectedImage: '../../../assets/images/access_card_selected.png',
      sub: [
        {
          index: '0',
          name: 'Bulk Upload',
          link: '/companies-rfid-bulkupload',
          sub: []
        },
        {
          index: '1',
          name: 'Tenant Allocation',
          link: '/disburse-member-card',
          sub: []
        },
      ],
    },
    {
      index: '2',
      name: 'Companies',
      image: '/assets/images/companies-inactive.png',
      selectedImage: '/assets/images/companies-active.png',
      link: '/companies/companies-list',
      sub: [],
    },
    {
      index: '3',
      name: 'Members',
      image: '/assets/images/members-inactive.png',
      selectedImage: '/assets/images/members-active.png',
      link: '/members/members-list',
      sub: [],
    },
    {
      index: '4',
      name: 'Meeting',
      link: '/meeting/meetingroom-list',
      image: '/assets/images/meeting-inactive.png',
      selectedImage: '/assets/images/meeting-active.png',
      sub: [],
    },

    {
      index: '5',
      name: 'Reports',
      image: '/assets/images/reports-inactive.png',
      selectedImage: '/assets/images/reports-active.png',
      link: '/reports',
      sub: [],
    },
    {
      index: '6',
      name: 'Credits',
      image: '/assets/images/credits-inactive.png',
      selectedImage: '/assets/images/credits-active.png',
      link: '/credits',
      sub: [],
    },
    {
      index: '7',
      name: 'Contact',
      image: '/assets/images/contact-book.png',
      selectedImage: '/assets/images/contact-active.png',
      link: '/contact',
      sub: [],
    },
    {
      index: '8',
      name: 'VMS',
      image: '../../../assets/images/vms.png',
      selectedImage: '../../../assets/images/vms_active.png',
      link: '/bridgeplus-vms',
      sub: [],
    },
    {
      index: '9',
      name: 'Events',
      image: '../../../assets/images/Events-1.png',
      selectedImage: '../../../assets/images/events_active.png',
      link: '/events',
      sub: [],
    },
  ];

  // if the sidenav index changes here please change the index in check side nav pipe as well
  ParkiteNav = [
    {
      index: '0',
      name: 'Overview',
      image: '../../../assets/images/overview-inactive.png',
      selectedImage: '../../../assets/images/overview-active.png',
      link: '/parkite-overview',
      key: 'Overview',
      sub: [],
    },
    {
      index: '1',
      name: 'Reports',
      image: '/assets/images/reports-inactive.png',
      selectedImage: '/assets/images/reports-active.png',
      link: '/parkite-reports',
      key: 'Reports',
      sub: [],
    },
    {
      index: '2',
      name: 'Company',
      image: '../../../assets/images/park-info.png',
      selectedImage: '../../../assets/images/park-info-active.png',
      link: '/company',
      key: 'Company',
      sub: [
        {
          index: '0',
          name: 'View',
          link: '/company',
          subkey: 'View',
          sub: [],
        },
        {
          index: '1',
          name: 'Add Company',
          link: '/company/add-company',
          subkey: 'Create',
          sub: [],
        },
      ],
    },
    {
      index: '3',
      name: 'VMS Approval',
      image: '../../../assets/images/vms.png',
      selectedImage: '../../../assets/images/vms_active.png',
      key: 'VMS/Bulk Invite',
      sub: [
        {
          index: '0',
          name: 'Invite',
          link: '/bulk-invite-approval',
          subkey: 'View',
          sub: [],
        },
        // {
        //   index: '1',
        //   name: 'Access',
        //   link: '/whitelist',
        //   subkey: 'View',
        //   sub: [],
        // },
      ],
    },
    {
      index: '4',
      name: 'Facility Booking',
      image: '../../../assets/images/Facility Booking.png',
      selectedImage: '../../../assets/images/Facility Booking Copy (4).png',
      link: '/facility',
      key: 'Facility Booking',
      sub: [],
    },
    {
      index: '5',
      name: 'Events',
      image: '../../../assets/images/Events-1.png',
      selectedImage: '../../../assets/images/events_active.png',
      link: '/events',
      key: 'Events',
      sub: [
        {
          index: '0',
          name: 'View',
          link: '/events',
          subkey: 'View',
          sub: [],
        },
        {
          index: '1',
          name: 'Create Event',
          link: '/events/create-event',
          subkey: 'Create',
          sub: [],
        },
      ],
    },
    {
      index: '6',
      name: 'Food Court Management',
      image: '../../../assets/images/food_court.png',
      selectedImage: '../../../assets/images/food_court_selected.png',
      key: 'Food Court',
      sub: [
        {
          index: '0',
          name: 'View Food Courts',
          link: '/list-food-court',
          subkey: 'View',
          sub: []
        },
        {
          index: '1',
          name: 'Add Food Court',
          link: '/create-food-court',
          subkey: 'Create',
          sub: []
        },
        {
          index: '2',
          name: 'Add Vendor Details',
          link: '/create-food-vendor',
          subkey: 'CreateVendor',
          sub: []
        },
      ],
    },
    {
      index: '7',
      name: 'Park Info',
      image: './assets/images/park-info.png',
      selectedImage: './assets/images/park-info-active.png',
      link: '/park-info',
      key: 'Park Info',
      sub: [],
    },
    {
      index: '8',
      name: 'Surveys and Polls',
      image: '../../../assets/images/create_and_view.png',
      selectedImage: '../../../assets/images/create_and_view_selected.png',
      key: 'Survey & Polls',
      sub: [
        {
          index: '0',
          name: 'Create',
          link: '/create-survey',
          subkey: 'Create',
          sub: [],
        },
        {
          index: '1',
          name: 'View',
          link: '/list-survey',
          subkey: 'View',
          sub: [],
        },
      ],
    },
    // {
    //   index: '9',
    //   name: 'Emergency Info',
    //   image: '../../../assets/images/manage_services.png',
    //   selectedImage: '../../../assets/images/manage_services_active.png',
    //   key: 'Emergency Info',
    //   sub: [
    //     {
    //       index: '0',
    //       name: 'Create',
    //       link: '/create-emergency-info',
    //       sub: [],
    //       subkey: 'Create'
    //     }
    //   ],
    // },
    {
      index: '10',
      name: 'GST',
      image: '/assets/images/charges-inactive.png',
      selectedImage: '/assets/images/charges-active.png',
      link: '/update-gst',
      key: 'GST',
      sub: [],
    },
    {
      index: '11',
      name: 'Manage Services',
      image: '../../../assets/images/manage_services.png',
      selectedImage: '../../../assets/images/manage_services_active.png',
      key: 'Managed Services',
      sub: [
        {
          index: '0',
          name: 'Create',
          link: '/landscaping-and-vegetation',
          subkey: 'Create',
          sub: [],
        },
        {
          index: '1',
          name: 'View',
          link: '/list-of-plants-trees',
          subkey: 'View',
          sub: [],
        },
      ],
    },
    {
      index: '12',
      name: 'Deals',
      image: '../../../assets/images/deals.png',
      selectedImage: '../../../assets/images/Deals_active.png',
      link: '/deals',
      key: 'Deals',
      sub: [
        {
          index: '0',
          name: 'View',
          link: '/deals',
          subkey: 'View',
          sub: [],
        },
        {
          index: '1',
          name: 'Add New Deal',
          link: '/deals/add-deal',
          subkey: 'Create',
          sub: [],
        },
      ],
    },
    {
      index: '13',
      name: 'Bulletins',
      image: '../../../assets/images/bulletin.png',
      selectedImage: '../../../assets/images/Bulletins_active.png',
      link: '/bulletins',
      key: 'Bulletins',
      sub: [
        {
          index: '0',
          name: 'View',
          link: '/bulletins',
          subkey: 'View',
          sub: [],
        },
        {
          index: '1',
          name: 'Add New Bulletin',
          link: '/bulletins/add-bulletin',
          subkey: 'Create',
          sub: [],
        },
      ],
    },
    {
      index: '14',
      name: 'FAQs',
      image: './assets/images/FAQs.png',
      selectedImage: './assets/images/FAQs_active.png',
      link: '/faq',
      key: 'FAQ',
      sub: [
        {
          index: '0',
          name: 'View',
          link: '/faq',
          subkey: 'View',
          sub: [],
        },
        {
          index: '1',
          name: 'Add FAQ',
          link: '/add-faq',
          subkey: 'Create',
          sub: [],
        },
      ],
    },
    {
      index: '15',
      name: 'User/Role Management',
      image: '../../../assets/images/user-role-deactive.png',
      selectedImage: '../../../assets/images/user-role-active.png',
      key: 'User Role Management',
      sub: [
        {
          index: '0',
          name: 'Role',
          link: '/role-permission',
          subkey: 'Create',
          sub: []
        },
        {
          index: '1',
          name: 'User',
          link: '/user-role-permission',
          subkey: 'View',
          sub: []
        },
      ],
    },
    // {
    //   index: '16',
    //   name: 'Meeting Rooms',
    //   image: '../../../assets/images/Events-1.png',
    //   selectedImage: '../../../assets/images/events_active.png',
    //   key: 'Meeting Room',
    //   sub: [
    //     {
    //       index: '0',
    //       name: 'View',
    //       link: '/meeting-room/view-meeting-room',
    //       subkey: 'View',
    //       sub: [],
    //     },
    //     {
    //       index: '1',
    //       name: 'Create Meeting Room',
    //       link: '/meeting-room/create-meeting-room',
    //       subkey: 'Create',
    //       sub: [],
    //     },
    //   ],
    // },
  ];

  tempParkiteNav = [
    {
      index: '0',
      name: 'Overview',
      image: '../../../assets/images/overview-inactive.png',
      selectedImage: '../../../assets/images/overview-active.png',
      link: '/parkite-overview',
      key: 'Overview',
      sub: [],
    },
    {
      index: '1',
      name: 'Reports',
      image: '/assets/images/reports-inactive.png',
      selectedImage: '/assets/images/reports-active.png',
      link: '/parkite-reports',
      key: 'Reports',
      sub: [],
    },
    {
      index: '2',
      name: 'Company',
      image: '../../../assets/images/park-info.png',
      selectedImage: '../../../assets/images/park-info-active.png',
      link: '/company',
      key: 'Company',
      sub: [
        {
          index: '0',
          name: 'View',
          link: '/company',
          subkey: 'View',
          sub: [],
        },
        {
          index: '1',
          name: 'Add Company',
          link: '/company/add-company',
          subkey: 'Create',
          sub: [],
        },
      ],
    },
    {
      index: '3',
      name: 'VMS Approval',
      image: '../../../assets/images/vms.png',
      selectedImage: '../../../assets/images/vms_active.png',
      key: 'VMS/Bulk Invite',
      sub: [
        {
          index: '0',
          name: 'Invite',
          link: '/bulk-invite-approval',
          subkey: 'View',
          sub: [],
        },
        // {
        //   index: '1',
        //   name: 'Access',
        //   link: '/whitelist',
        //   subkey: 'View',
        //   sub: [],
        // },
      ],
    },
    {
      index: '4',
      name: 'Facility Booking',
      image: '../../../assets/images/Facility Booking.png',
      selectedImage: '../../../assets/images/Facility Booking Copy (4).png',
      link: '/facility',
      key: 'Facility Booking',
      sub: [],
    },
    {
      index: '5',
      name: 'Events',
      image: '../../../assets/images/Events-1.png',
      selectedImage: '../../../assets/images/events_active.png',
      link: '/events',
      key: 'Events',
      sub: [
        {
          index: '0',
          name: 'View',
          link: '/events',
          subkey: 'View',
          sub: [],
        },
        {
          index: '1',
          name: 'Create Event',
          link: '/events/create-event',
          subkey: 'Create',
          sub: [],
        },
      ],
    },
    {
      index: '6',
      name: 'Food Court Management',
      image: '../../../assets/images/food_court.png',
      selectedImage: '../../../assets/images/food_court_selected.png',
      key: 'Food Court',
      sub: [
        {
          index: '0',
          name: 'View Food Courts',
          link: '/list-food-court',
          subkey: 'View',
          sub: []
        },
        {
          index: '1',
          name: 'Add Food Court',
          link: '/create-food-court',
          subkey: 'Create',
          sub: []
        },
        {
          index: '2',
          name: 'Add Vendor Details',
          link: '/create-food-vendor',
          subkey: 'CreateVendor',
          sub: []
        },
      ],
    },
    {
      index: '7',
      name: 'Park Info',
      image: './assets/images/park-info.png',
      selectedImage: './assets/images/park-info-active.png',
      link: '/park-info',
      key: 'Park Info',
      sub: [],
    },
    {
      index: '8',
      name: 'Surveys and Polls',
      image: '../../../assets/images/create_and_view.png',
      selectedImage: '../../../assets/images/create_and_view_selected.png',
      key: 'Survey & Polls',
      sub: [
        {
          index: '0',
          name: 'Create',
          link: '/create-survey',
          subkey: 'Create',
          sub: [],
        },
        {
          index: '1',
          name: 'View',
          link: '/list-survey',
          subkey: 'View',
          sub: [],
        },
      ],
    },
    // {
    //   index: '9',
    //   name: 'Emergency Info',
    //   image: '../../../assets/images/manage_services.png',
    //   selectedImage: '../../../assets/images/manage_services_active.png',
    //   key: 'Emergency Info',
    //   sub: [
    //     {
    //       index: '0',
    //       name: 'Create',
    //       link: '/create-emergency-info',
    //       sub: [],
    //       subkey: 'Create'
    //     }
    //   ],
    // },
    {
      index: '10',
      name: 'GST',
      image: '/assets/images/charges-inactive.png',
      selectedImage: '/assets/images/charges-active.png',
      link: '/update-gst',
      key: 'GST',
      sub: [],
    },
    {
      index: '11',
      name: 'Manage Services',
      image: '../../../assets/images/manage_services.png',
      selectedImage: '../../../assets/images/manage_services_active.png',
      key: 'Managed Services',
      sub: [
        {
          index: '0',
          name: 'Create',
          link: '/landscaping-and-vegetation',
          subkey: 'Create',
          sub: [],
        },
        {
          index: '1',
          name: 'View',
          link: '/list-of-plants-trees',
          subkey: 'View',
          sub: [],
        },
      ],
    },
    {
      index: '12',
      name: 'Deals',
      image: '../../../assets/images/deals.png',
      selectedImage: '../../../assets/images/Deals_active.png',
      link: '/deals',
      key: 'Deals',
      sub: [
        {
          index: '0',
          name: 'View',
          link: '/deals',
          subkey: 'View',
          sub: [],
        },
        {
          index: '1',
          name: 'Add New Deal',
          link: '/deals/add-deal',
          subkey: 'Create',
          sub: [],
        },
      ],
    },
    {
      index: '13',
      name: 'Bulletins',
      image: '../../../assets/images/bulletin.png',
      selectedImage: '../../../assets/images/Bulletins_active.png',
      link: '/bulletins',
      key: 'Bulletins',
      sub: [
        {
          index: '0',
          name: 'View',
          link: '/bulletins',
          subkey: 'View',
          sub: [],
        },
        {
          index: '1',
          name: 'Add New Bulletin',
          link: '/bulletins/add-bulletin',
          subkey: 'Create',
          sub: [],
        },
      ],
    },
    {
      index: '14',
      name: 'FAQs',
      image: './assets/images/FAQs.png',
      selectedImage: './assets/images/FAQs_active.png',
      link: '/faq',
      key: 'FAQ',
      sub: [
        {
          index: '0',
          name: 'View',
          link: '/faq',
          subkey: 'View',
          sub: [],
        },
        {
          index: '1',
          name: 'Add FAQ',
          link: '/add-faq',
          subkey: 'Create',
          sub: [],
        },
      ],
    },
    {
      index: '15',
      name: 'User/Role Management',
      image: '../../../assets/images/user-role-deactive.png',
      selectedImage: '../../../assets/images/user-role-active.png',
      key: 'User Role Management',
      sub: [
        {
          index: '0',
          name: 'Role',
          link: '/role-permission',
          subkey: 'Create',
          sub: []
        },
        {
          index: '1',
          name: 'User',
          link: '/user-role-permission',
          subkey: 'View',
          sub: []
        },
      ],
    },
    // {
    //   index: '16',
    //   name: 'Meeting Rooms',
    //   image: '../../../assets/images/Events-1.png',
    //   selectedImage: '../../../assets/images/events_active.png',
    //   key: 'Meeting Room',
    //   sub: [
    //     {
    //       index: '0',
    //       name: 'View',
    //       link: '/meeting-room/view-meeting-room',
    //       subkey: 'View',
    //       sub: [],
    //     },
    //     {
    //       index: '1',
    //       name: 'Create Meeting Room',
    //       link: '/meeting-room/create-meeting-room',
    //       subkey: 'Create',
    //       sub: [],
    //     },
    //   ],
    // },
  ];
  modules: any;

  constructor(private rolepermissionService: RolepermissionService) {
    if (localStorage.getItem('claAdminPermissions')) {
      this.getUserPermissionMenu();
    }
    this.createSidebar();
  }

  getUserPermissionMenu() {
    const permissionData = JSON.parse(localStorage.getItem('claAdminPermissions'));
    if (permissionData.modulePermission.length > 0) {
      // Creating a parent-child array
      const result = permissionData.modulePermission.reduce((acc, item) => {
        const [parent, child] = item.split(":");
        const existingParent = acc.find(entry => entry.category === parent);

        if (existingParent) {
          existingParent.actions.push(child);
        } else {
          acc.push({ category: parent, actions: [child] });
        }
        return acc;
      }, []);

      // Filter masterArray based on matching keys with childArray's category
      this.tempParkiteNav = this.ParkiteNav = this.tempParkiteNav.filter(masterItem => {
        // Check if the key of masterItem exists in childArray
        return result.some(childItem => childItem.category === masterItem.key);
      });

      // assign the new menu to the master menu with child
      this.tempParkiteNav = this.ParkiteNav = this.filterMasterArrayWithSub(this.tempParkiteNav, result);
      // Print the filtered masterArray
      console.log(this.tempParkiteNav);
      if (this.tempParkiteNav.length >= this.defaultListCount) {
        localStorage.setItem('seeLess', 'false');
      } else {
        localStorage.setItem('seeLess', 'true');
      }

      // console.log(filteredMasterArray);
      // console.log(this.tempParkiteNav);
      // console.log(result);
    }
  }

  filterSubByActions(subArray, actions) {
    return subArray.filter(subItem => actions.includes(subItem.subkey));
  }

  // Filter the masterArray based on childArray
  filterMasterArrayWithSub(masterArray, childArray) {
    return masterArray.map((item: { key: any; sub: any[]; }) => {
      const matchingChild = childArray.find((child: { category: any; }) => child.category === item.key);
      if (matchingChild) {
        const filteredSub = item.sub.filter(subItem => matchingChild.actions.includes(subItem.subkey)); // this.filterSubByActions(item.sub, matchingChild.actions); 
        return { ...item, sub: filteredSub };
      } else {
        return item;
      }
    });
  }

  createSidebar() {
    if (this.portalType == 'Bridge+') {
      this.sideNav = this.bridgePlusNav;
    } else {
      if (this.isPrivilege) {
        this.sideNav = this.tempParkiteNav;
      } else {
        this.sideNav = this.sideBarWithoutPriviledge();
      }
    }
    this.tempSelectedNav = this.sideNav;
    return this.sideNav;
  }

  sideBarWithoutPriviledge(status = false) {
    let newSideNav = [];
    let counterIndex = -1;
    let nav = status ? this.tempParkiteNav : this.ParkiteNav;

    nav.forEach((element) => {
      if (!this.excludeNav.includes(element.name)) {
        element.index = JSON.stringify(counterIndex + 1);
        newSideNav.push(element);
        counterIndex++;
      }
    });
    return newSideNav;
  }

  getSideNav() {
    this.isPrivilege =
      localStorage.getItem('hasPriviledge') == '1' ? true : false;
    return this.createSidebar();
  }

  routingChunks(params: {
    name: string;
    customUrl?: string;
    subNav?: string;
    subNavLink?: string;
  }) {
    let filteredObj = this.sideNav.find((o) => o.name === params.name);
    let finalObj: { index: string; link: string; name: string; sub?: any[] };
    if (filteredObj) {
      finalObj = {
        index: filteredObj.index,
        name: filteredObj.name,
        link: filteredObj.link,
      };

      if (filteredObj.sub.length > 0 && params.subNav) {
        finalObj['sub'] = [filteredObj.sub[params.subNav]];
        if (params.subNavLink) {
          finalObj['sub'][0].link = params.subNavLink;
        }
      }
      if (params.customUrl) {
        finalObj['link'] = params.customUrl;
      }
    }
    return finalObj;
  }

  async updateRoutingChunks(params: { name: string; subNav: number }) {

    if (this.portalType == 'Bridge+') {
      this.tempSelectedNav = this.tempBridgePlusNav;
    } else {
      if (this.isPrivilege) {
        this.tempSelectedNav = this.tempParkiteNav;
      } else {
        this.tempSelectedNav = this.sideBarWithoutPriviledge(true);
      }
    }

    let filteredObj = this.tempSelectedNav.find((o) => o.name === params.name);
    let finalObj: { index: string; link: string; name: string; sub?: any[] };

    if (filteredObj) {
      finalObj = {
        index: filteredObj.index,
        name: filteredObj.name,
        link: filteredObj.link,
      };

      if (filteredObj.sub.length > 0) {
        finalObj['sub'] = [filteredObj.sub[params.subNav]];
      }
    }

    return finalObj;
  }
}